import {
  DoodProductModel,
  TreeCatalogCategoryWithCategoryEntity,
} from '@core/models/product.model';

/**
 * A category stays visible when it has its own visible products or a descendant does.
 * Parent categories can hold products and subcategories at the same time.
 */
export function categoryHasVisibleProductInSubtree(
  node: TreeCatalogCategoryWithCategoryEntity,
  products: readonly DoodProductModel[],
): boolean {
  const hasOwnVisibleProduct =
    node.category?.products?.some(productId => {
      const product = products.find(item => item.id === productId);
      return !!product && !product.hidden;
    }) ?? false;

  const childHasVisibleProduct =
    node.children?.some(child => categoryHasVisibleProductInSubtree(child, products)) ?? false;

  return hasOwnVisibleProduct || childHasVisibleProduct;
}

export function removeCategoriesWithoutVisibleProducts(
  treeCatalogCategories: TreeCatalogCategoryWithCategoryEntity[],
  products: readonly DoodProductModel[],
): TreeCatalogCategoryWithCategoryEntity[] {
  return treeCatalogCategories
    .map(category => {
      const filteredChildren = removeCategoriesWithoutVisibleProducts(category.children, products);
      if (filteredChildren.length || categoryHasVisibleProductInSubtree(category, products)) {
        return {
          ...category,
          children: filteredChildren,
        };
      }
      return null;
    })
    .filter((category): category is TreeCatalogCategoryWithCategoryEntity => category !== null);
}
